<template>
  <v-card class="main-shipment">
    <v-row
      class="loader fill-height py-6"
      align="center"
      justify="center"
      v-if="isMainShipmentFormLoading || retrievingEditExportJob"
    >
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </v-row>
    <div v-else>
      <v-card-text class="px-8 py-6">
        <ValidationObserver @keydown.tab="focusNext" v-slot="{ passes }">
          <v-row>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
              <AutoComplete
                v-model="destinationCountryDropdownValue"
                :items="countries"
                item-text="name"
                :return-object="true"
                rules="required"
                :loading="isMainShipmentFormLoading || savingExportJob"
                label="Destination Country"
              />
            </v-col>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
              <AutoComplete
                rules="required"
                v-model="portCodeOfDestinationDropdownValue"
                item-text="text"
                :items="foreignPorts"
                :return-object="true"
                :loading="isMainShipmentFormLoading || savingExportJob"
                label="Destination Port"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
              <AutoComplete
                v-model="dischargeCountryDropdownValue"
                :items="countries"
                :return-object="true"
                item-text="name"
                rules="required"
                :loading="isMainShipmentFormLoading || savingExportJob"
                label="Discharge Country"
              />
            </v-col>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
              <AutoComplete
                rules="required"
                v-model="portCodeOfDischargeDropdownValue"
                :items="foreignPorts"
                item-text="text"
                :return-object="true"
                :loading="isMainShipmentFormLoading || savingExportJob"
                label="Discharge Port"
              />
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="3">
              <TextField
                showIcons
                :showOnlyErrorIcons="true"
                :loading="isMainShipmentFormLoading || savingExportJob"
                label="MLB No"
              />
            </v-col>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="3">
              <DateField :loading="isMainShipmentFormLoading || savingExportJob" :inputLabel="'Date'" />
            </v-col>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="3">
              <TextField
                showIcons
                :showOnlyErrorIcons="true"
                :loading="isMainShipmentFormLoading || savingExportJob"
                label="HBL No"
              />
            </v-col>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="3">
              <DateField :loading="isMainShipmentFormLoading || savingExportJob" :inputLabel="'Date'" />
            </v-col>
          </v-row> -->
          <v-row>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="3">
              <AutoComplete
                :items="goodsStuffedAt"
                item-text="text"
                :return-object="true"
                v-model="shipmentGoodsStuffedAtDropdownValue"
                :loading="isMainShipmentFormLoading || savingExportJob"
                label="Goods Stuffed At"
              />
            </v-col>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="3">
              <v-checkbox hide-details v-model="sampleAccompanied" label="Sample Forwarded"></v-checkbox>
            </v-col>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="3">
              <TextField
                type="number"
                showIcons
                required
                v-model="loosePackages"
                :showOnlyErrorIcons="true"
                :loading="isMainShipmentFormLoading || savingExportJob"
                label="Loose Packages"
              />
            </v-col>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="3">
              <TextField
                v-model="noOfContainers"
                rules="required"
                required
                :loading="isMainShipmentFormLoading || savingExportJob"
                label="No of Containers"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="3">
              <TextField
                type="number"
                showIcons
                required
                v-model="totalNoOfPackages"
                :showOnlyErrorIcons="true"
                :loading="isMainShipmentFormLoading || savingExportJob"
                label="Total No of Packages"
              />
            </v-col>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="3">
              <AutoComplete
                :items="units"
                v-model="packingUnitDropdownValue"
                :return-object="true"
                item-text="text"
                rules="required"
                :loading="isMainShipmentFormLoading || savingExportJob"
                label="Packing Unit"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="3">
              <TextField
                showIcons
                type="number"
                v-model="grossWeight"
                :showOnlyErrorIcons="true"
                :loading="isMainShipmentFormLoading || savingExportJob"
                label="Gross Weight"
              />
            </v-col>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="3">
              <TextField
                type="number"
                v-model="netWeight"
                showIcons
                :showOnlyErrorIcons="true"
                :loading="isMainShipmentFormLoading || savingExportJob"
                label="Net Weight"
              />
            </v-col>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="3">
              <AutoComplete
                :items="units"
                v-model="unitOfMeasurementDropdownValue"
                :return-object="true"
                item-text="text"
                rules="required"
                :loading="isMainShipmentFormLoading || savingExportJob"
                label="Weight Unit"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="3">
              <AutoComplete
                :items="sealTypes"
                item-text="text"
                item-value="textIdentifier"
                :loading="isMainShipmentFormLoading || savingExportJob"
                v-model="sealType"
                label="Seal Type"
              />
            </v-col>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="3">
              <AutoComplete
                :items="natureOfCargo"
                v-model="shipmentNatureOfCargo"
                item-value="textIdentifier"
                item-text="text"
                rules="required"
                :loading="isMainShipmentFormLoading || savingExportJob"
                label="Nature of Cargo"
              />
            </v-col>
            <v-col cols="12" :xs="12" :sm="6" :md="3">
              <AutoComplete
                :items="states"
                :return-object="true"
                v-model="stateCodeOfOriginDropdownValue"
                item-text="text"
                :loading="isMainShipmentFormLoading || savingExportJob"
                label="State of Origin"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
              <div class="d-sm-flex justify-start" :class="{ 'text-center': breakpointXs }">
                <v-btn
                  width="140"
                  color="info"
                  large
                  class="white--text"
                  :loading="isMainShipmentFormLoading || savingExportJob"
                  @click="$router.push({ name: 'dashboard.export.container' })"
                >
                  <v-icon class="font-weight-bold fs-15 mr-2">fa fa-arrow-circle-left</v-icon>
                  <span class="font-weight-bold fs-15">Previous</span>
                </v-btn>
              </div>
            </v-col>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
              <div class="d-sm-flex justify-end" :class="{ 'text-center': breakpointXs }">
                <v-btn
                  width="140"
                  color="button-primary"
                  large
                  class="white--text"
                  :loading="isMainShipmentFormLoading || savingExportJob"
                  @click="passes(saveMainShipment)"
                >
                  <span class="font-weight-bold fs-15">Save</span>
                </v-btn>
                <div class="ml-2 mr-2 my-1"></div>
                <v-btn
                  width="140"
                  color="info"
                  large
                  class="white--text"
                  :loading="isMainShipmentFormLoading || savingExportJob"
                  @click="$emit('change-tab', 1)"
                >
                  <span class="font-weight-bold fs-15">Next</span>
                  <v-icon class="font-weight-bold fs-15 ml-2">fa fa-arrow-circle-right</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </ValidationObserver>
      </v-card-text>
    </div>
  </v-card>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import TextField from "@/components/TextField";
import AutoComplete from "@/components/AutoComplete";
import * as MT from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/store/mutationTypes";
import handleExportJobMixin from "@/modules/DashboardModule/modules/ImportExportModule/mixins/handleExportJobMixin";
import commonMethodsMixin from "@/modules/commonMethodsMixin";
export default {
  name: "MainShipmentTab",
  components: {
    AutoComplete,
    TextField,
    ValidationObserver
  },
  data() {
    return {
      isMainShipmentFormLoading: false,
      previousNetweight: null
    };
  },
  mounted() {
    this.previousNetweight = this.$store.state.ExportModuleStore.sbMain.netWeight;
  },
  beforeDestroy() {
    // this.makeFieldsNull();
  },
  watch: {
    resetShipment(newvalue) {
      if (newvalue) {
        this.makeFieldsNull();
        this.$emit("clear-reset-shipment", false);
      } else {
        this.$emit("clear-reset-shipment", false);
      }
    }
  },
  props: {
    resetShipment: {
      type: Boolean,
      default: false
    }
  },
  mixins: [commonMethodsMixin, handleExportJobMixin],
  methods: {
    makeFieldsNull() {
      this.destinationCountry = null;
      this.dischargeCountry = null;
      this.shipmentGoodsStuffedAt = null;
      this.sampleAccompanied = null;
      this.totalNoOfPackages = null;
      this.loosePackages = null;
      this.sealType = null;
      this.shipmentNatureOfCargo = null;
      this.destinationCountryDropdownValue = "";
      this.portCodeOfDestinationDropdownValue = "";
      this.stateCodeOfOriginDropdownValue = "";
      this.portCodeOfDischargeDropdownValue = "";
      this.dischargeCountryDropdownValue = "";
      this.shipmentGoodsStuffedAtDropdownValue = "";
      this.sealTypeDropdownValue = "";
      this.shipmentNatureOfCargoDropdownValue = "";
      this.unitOfMeasurementDropdownValue = "";
      this.packingUnit = null;
      this.grossWeight = null;
      this.netWeight = null;
      this.noOfContainers = null;
      return;
    },
    saveMainShipment() {
      this.saveExportJob();
    }
  },
  computed: {
    countries() {
      return this.$store.getters.countries;
    },
    units() {
      return this.$store.getters.units;
    },
    sealTypes() {
      return this.$store.getters.sealTypes;
    },
    states() {
      return this.$store.getters.states;
    },
    homePorts() {
      return this.$store.getters.homePorts;
    },
    foreignPorts() {
      return this.$store.getters.foreignPorts;
    },
    goodsStuffedAt() {
      return this.$store.getters.goodsStuffedAt;
    },
    natureOfCargo() {
      return this.$store.getters.natureOfCargo;
    },
    destinationCountryDropdownValue: {
      get() {
        return this.$store.state.ExportModuleStore.sbMain.countryCodeOfFinalDestinationDropdownValue;
      },
      set(destinationCountryObject) {
        this.$store.commit(MT.SET_SBMAIN_COUNTRY_CODE_OF_FINAL_DESTINATION_DROPDOWN_VALUE, {
          value: destinationCountryObject.name
        });
        this.destinationCountry = destinationCountryObject.code;
      }
    },
    destinationCountry: {
      get() {
        return this.$store.state.ExportModuleStore.sbMain.countryCodeOfFinalDestination;
      },
      set(value) {
        this.$store.commit(MT.SET_SBMAIN_COUNTRY_CODE_OF_FINAL_DESTINATION, { value });
      }
    },
    portCodeOfDestinationDropdownValue: {
      get() {
        return this.$store.state.ExportModuleStore.sbMain.portCodeOfDestinationDropdownValue;
      },
      set(portCodeOfDestinationObject) {
        this.$store.commit(MT.SET_SBMAIN_PORT_CODE_OF_FINAL_DESTINATION_DROPDOWN_VALUE, {
          value: portCodeOfDestinationObject.text
        });
        this.portCodeOfDestination = portCodeOfDestinationObject.code;
      }
    },
    stateCodeOfOriginDropdownValue: {
      get() {
        return this.$store.state.ExportModuleStore.sbMain.stateCodeOfOriginExporterDropdownValue;
      },
      set(value) {
        this.$store.commit(MT.SET_SBMAIN_EXPORTER_STATE_CODE_OF_ORIGIN_EXPORTER_DROPDOWN_VALUE, { value: value.text });
        this.stateCodeOfOrigin = value.code;
      }
    },
    stateCodeOfOrigin: {
      get() {
        return this.$store.state.ExportModuleStore.sbMain.stateCodeOfOriginExporter;
      },
      set(value) {
        this.$store.commit(MT.SET_SBMAIN_EXPORTER_STATE_CODE_OF_ORIGIN_EXPORTER, { value });
      }
    },
    portCodeOfDestination: {
      get() {
        return this.$store.state.ExportModuleStore.sbMain.portCodeOfDestination;
      },
      set(value) {
        this.$store.commit(MT.SET_SBMAIN_PORT_CODE_OF_FINAL_DESTINATION, { value });
      }
    },
    portCodeOfDischargeDropdownValue: {
      get() {
        return this.$store.state.ExportModuleStore.sbMain.portCodeOfDischargeDropdownValue;
      },
      set(portCodeOfDischargeObject) {
        this.$store.commit(MT.SET_SBMAIN_PORT_CODE_OF_DISCHARGE_DROPDOWN_VALUE, {
          value: portCodeOfDischargeObject.text
        });
        this.portCodeOfDischarge = portCodeOfDischargeObject.code;
      }
    },

    portCodeOfDischarge: {
      get() {
        return this.$store.state.ExportModuleStore.sbMain.portCodeOfDischarge;
      },
      set(value) {
        this.$store.commit(MT.SET_SBMAIN_PORT_CODE_OF_DISCHARGE, { value });
      }
    },
    dischargeCountryDropdownValue: {
      get() {
        return this.$store.state.ExportModuleStore.sbMain.countryCodeOfDischargeDropdownValue;
      },
      set(dischargeCountryObject) {
        this.$store.commit(MT.SET_SBMAIN_COUNTRY_CODE_OF_DISCHARGE_DROPDOWN_VALUE, {
          value: dischargeCountryObject.name
        });
        this.dischargeCountry = dischargeCountryObject.code;
      }
    },
    dischargeCountry: {
      get() {
        return this.$store.state.ExportModuleStore.sbMain.countryCodeOfDischarge;
      },
      set(value) {
        this.$store.commit(MT.SET_SBMAIN_COUNTRY_CODE_OF_DISCHARGE, { value });
      }
    },
    shipmentGoodsStuffedAtDropdownValue: {
      get() {
        const selectedshipmentGoodsStuffedAt = this.shipmentGoodsStuffedAt;
        if (selectedshipmentGoodsStuffedAt !== "" && !!selectedshipmentGoodsStuffedAt) {
          return this.goodsStuffedAt.find(type => type.textIdentifier.includes(selectedshipmentGoodsStuffedAt)).text;
        } else {
          return this.goodsStuffedAt[0];
        }
      },
      set(shipmentGoodsStuffedAtObject) {
        this.$store.commit(MT.SET_STUFF_GOODS_STUFFED_AT, {
          value: shipmentGoodsStuffedAtObject.textIdentifier
        });
      }
    },

    shipmentGoodsStuffedAt: {
      get() {
        return this.$store.state.ExportModuleStore.stuff.factoryStuffed;
      },
      set(value) {
        this.$store.commit(MT.SET_STUFF_GOODS_STUFFED_AT, { value });
      }
    },
    sampleAccompanied: {
      get() {
        return this.$store.state.ExportModuleStore.stuff.sampleAccompanied;
      },
      set(value) {
        this.$store.commit(MT.SET_STUFF_SAMPLE_ACCOMPANIED, { value });
      }
    },
    totalNoOfPackages: {
      get() {
        return this.$store.state.ExportModuleStore.sbMain.totalNoOfPackages;
      },
      set(value) {
        this.$store.commit(MT.SET_SBMAIN_TOTAL_NO_OF_PACKAGES, { value });
      }
    },
    loosePackages: {
      get() {
        return this.$store.state.ExportModuleStore.sbMain.noOfLoosePackets;
      },
      set(value) {
        this.$store.commit(MT.SET_SBMAIN_NO_OF_LOOSE_PACKETS, { value });
      }
    },
    noOfContainers: {
      get() {
        return this.$store.state.ExportModuleStore.sbMain.noOfContainers;
      },
      set(value) {
        this.$store.commit(MT.SET_SBMAIN_NO_OF_CONTAINERS, { value });
      }
    },
    sealTypeDropdownValue: {
      get() {
        const selectedsealType = this.sealType;
        if (selectedsealType !== "" && !!selectedsealType) {
          return this.sealTypes.find(type => type.textIdentifier.includes(selectedsealType)).textIdentifier;
        } else {
          return this.sealTypes[0];
        }
      },
      set(sealTypeObject) {
        this.$store.commit(MT.SET_SBMAIN_SEAL_TYPE, {
          value: sealTypeObject.textIdentifier
        });
      }
    },

    sealType: {
      get() {
        return this.$store.state.ExportModuleStore.sbMain.sealType;
      },
      set(value) {
        // const selfSealType = "S";
        // const excludeIfSelfSeal = ["LB", "DB", "NA"];
        // if (value === selfSealType) {
        //   this.$store.getters.natureOfCargo.filter(natureOfCargo => {
        //     return !excludeIfSelfSeal.includes(natureOfCargo.textIdentifier);
        //   });
        //   this.$forceUpdate();
        // }
        this.$store.commit(MT.SET_SBMAIN_SEAL_TYPE, { value });
      }
    },
    shipmentNatureOfCargoDropdownValue: {
      get() {
        const selectedShipmentNatureOfCargo = this.shipmentNatureOfCargo;
        if (selectedShipmentNatureOfCargo !== "" && !!selectedShipmentNatureOfCargo) {
          return this.natureOfCargo.find(type => type.textIdentifier.includes(selectedShipmentNatureOfCargo))
            .textIdentifier;
        } else {
          return this.natureOfCargo[0];
        }
      },
      set(shipmentNatureOfCargoObject) {
        this.$store.commit(MT.SET_SBMAIN_NATURE_OF_CARGO, {
          value: shipmentNatureOfCargoObject.textIdentifier
        });
      }
    },
    shipmentNatureOfCargo: {
      get() {
        return this.$store.state.ExportModuleStore.sbMain.natureOfCargo;
      },
      set(value) {
        this.$store.commit(MT.SET_SBMAIN_NATURE_OF_CARGO, { value });
      }
    },
    grossWeight: {
      get() {
        return this.$store.state.ExportModuleStore.sbMain.grossWeight;
      },
      set(value) {
        this.$store.commit(MT.SET_SBMAIN_GROSS_WEIGHT, { value });
      }
    },
    netWeight: {
      get() {
        return this.$store.state.ExportModuleStore.sbMain.netWeight;
      },
      set(value) {
        if (value > this.grossWeight) {
          this.netweight = this.previousNetweight;
          var prevNetWeight = this.previousNetweight;
          const errMessage = "Net weight must be less than gross weight";
          this.$store.commit(MT.SET_SBMAIN_NET_WEIGHT, { prevNetWeight });
          this.throwErrorMessage(errMessage);
          return;
        } else {
          this.$store.commit(MT.SET_SBMAIN_NET_WEIGHT, { value });
          this.previousNetweight = value;
          return;
        }
      }
    },
    unitOfMeasurementDropdownValue: {
      get() {
        return this.$store.state.ExportModuleStore.sbMain.unitOfMeasurementDropdownValue;
      },
      set(unitOfMeasurementObject) {
        this.$store.commit(MT.SET_SBMAIN_UNIT_OF_MEASUREMENT_DROPDOWN_VALUE, {
          value: unitOfMeasurementObject.text
        });
        this.unitOfMeasurement = unitOfMeasurementObject.textIdentifier;
      }
    },
    unitOfMeasurement: {
      get() {
        return this.$store.state.ExportModuleStore.item.unitOfMeasurement;
      },
      set(value) {
        this.$store.commit(MT.SET_SBMAIN_UNIT_OF_MEASUREMENT, { value });
      }
    },
    packingUnitDropdownValue: {
      get() {
        return this.$store.state.ExportModuleStore.sbMain.packingUnitDropdownValue;
      },
      set(packingUnitObject) {
        this.$store.commit(MT.SET_SBMAIN_PACKING_UNIT_DROPDOWN_VALUE, {
          value: packingUnitObject.text
        });
        this.packingUnit = packingUnitObject.textIdentifier;
      }
    },
    packingUnit: {
      get() {
        return this.$store.state.ExportModuleStore.sbMain.packingUnit;
      },
      set(value) {
        this.$store.commit(MT.SET_SBMAIN_PACKING_UNIT, { value });
      }
    }
  }
};
</script>
